import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AdminNotificationBell from '../../components/AdminNotificationBell';
import PuzzleRecordsAdmin from '../../components/PuzzleRecordsAdmin';
import PuzzleImagesAdmin from '../../components/PuzzleImagesAdmin';
import TabBar from '../../components/TabBar';
import BizSwitch from '../../components/BizSwitch';
import SubTabs from '../../components/SubTabs';
import { setBizMode } from '../../utils/bizMode';
import { ArrowLeft, Puzzle } from 'lucide-react';

// 后台 · 证券识别记录（管理员全量 / 代理商名下），两个标签（名称和排五的“识别记录 | 图片管理”对齐）：
//   识别记录：待核实、解锁、更正字段、重新合成、错误上传（原“审核”标签，全部功能不变）
//   图片管理：看图、批量导出、导出后清理磁盘（原“图片与导出”标签，全部功能不变）
// 用 ?tab=images 直接打开第二个标签；旧地址 /admin/puzzle-images 会跳到这里。
// 两个标签只在第一次打开时才加载；切换后各自的筛选、页码、已加载的列表都保留。
export default function AdminPuzzleRecordsPage() {
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const userId = params.get('userId') || undefined;
  const tab = params.get('tab') === 'images' ? 'images' : 'review';
  const [visited, setVisited] = useState({ [tab]: true });

  const goTab = (t) => {
    setVisited(v => ({ ...v, [t]: true }));
    const next = new URLSearchParams(params);
    if (t === 'images') next.set('tab', 'images'); else next.delete('tab');
    setParams(next, { replace: true });
  };

  const TABS = [['review', '识别记录'], ['images', '图片管理']];
  return (
    <div className="page">
      <div className="header" style={{ display: 'flex', alignItems: 'center' }}>
        <button onClick={() => navigate('/admin')}
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px 8px 4px 0', display: 'flex', alignItems: 'center', color: 'var(--c-primary)' }}>
          <ArrowLeft size={18} />
        </button>
        <span style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 8 }}><Puzzle size={16} /> 证券识别记录</span>
        <AdminNotificationBell />
      </div>
      <div style={{ padding: '10px 16px 0' }}>
        {/* 切到排五：在“图片管理”标签就去排五图片管理，否则去排五 OCR 记录（和合并前的去向一致） */}
        <BizSwitch value="puzzle" onChange={(k) => {
          if (k === 'legacy') { setBizMode('legacy'); navigate(tab === 'images' ? '/admin/images' : '/admin/ocr', { replace: true }); }
        }} />
      </div>
      <div style={{ padding: '8px 16px 0' }}>
        <SubTabs items={TABS} value={tab} onChange={goTab} />
      </div>
      <div style={{ padding: '12px 16px' }}>
        {visited.review && (
          <div style={{ display: tab === 'review' ? 'block' : 'none' }}>
            <PuzzleRecordsAdmin userId={userId} />
          </div>
        )}
        {visited.images && (
          <div style={{ display: tab === 'images' ? 'block' : 'none' }}>
            <PuzzleImagesAdmin userId={userId} />
          </div>
        )}
      </div>
      <TabBar mode="admin" />
    </div>
  );
}
